import React from 'react'

export type TileSectionProps = {
  children: React.ReactNode
}

export const TileSection: React.FC<TileSectionProps> = ({ children }) => {
  return (
    <div className="flex flex-row flex-wrap items-center justify-center sm:justify-start gap-x-7 gap-y-7">
      {children}
    </div>
  )
}
